const PrintRow = ({ children }: { children: JSX.Element[] }) => {
  return (
    <div className="flex print mb-4">
      <div className="w-1/2 mr-2">{children[0]}</div>
      <div className="w-1/2">{children[1]}</div>
    </div>
  );
};
export default PrintRow;
